import { getInitialState, getPath } from "../../utils";

const initialState = {
  driverMedalsList: [],
  driverMetricsList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_DRIVER_MEDALS_DETAILS":
      return setDriverMedalsDetails(state, action);
    case "RESET_STATE_DRIVER_MEDALS":
      return resetDriverMedalState(state, action);
    default:
      return state;
  }
}

const setDriverMedalsDetails = (state, action) => {
  return {
    ...state,
    driverMedalsList: getPath(action.payload, "tier_data.medals", []),
    driverMetricsList: getPath(action.payload, "tier_data.metrics", []),
  };
};

const resetDriverMedalState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
